'use client';
import { useEffect, useRef } from 'react';
import type { Unsubscribe } from 'redux';

import type { AppStore } from '~store/index';

import { StorageScope } from '../../utils';

type TProps = {
	store: AppStore;
};

export const StorageScopeInitializer = ({ store }: TProps) => {
	const subscribed = useRef(false);
	const unsubscriber = useRef<Unsubscribe | null>(null);

	useEffect(() => {
		if (store && !subscribed.current) {
			subscribed.current = true;
			unsubscriber.current = store.subscribe(() => {
				if (
					StorageScope &&
					store.getState().auth.info.id &&
					!StorageScope.scope
				) {
					StorageScope.scope = store.getState().auth.info.id;
				}
			});
		}

		return () => {
			if (StorageScope.scope) {
				unsubscriber.current?.();
				StorageScope.clean();
				subscribed.current = false;
			}
		};
	}, [store]);

	return <></>;
};
